import { useTranslation } from 'react-i18next';
import { BoundedContent, Box, Column, FlexBox, GridContainer, H2, Row } from '@vp/swan';
import FAQAccordion from '../../../../components/FAQAccordion/FAQAccordion';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { reactNodeToSanitizedText } from '../../../../utils/reactNodeToSanitizedText';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';
import LogomakerCTA from '../LogomakerCTA/LogomakerCTA';
import { useFaqData } from './useFaqData';
import type { FAQSchema } from '../../../../components/FAQAccordion/FAQAccordion';

const Faq = () => {
    const { i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);
    const faqData = useFaqData();

    const faqSchemaData: FAQSchema[] = faqData.map((faq) => ({
        question: reactNodeToSanitizedText(faq.question),
        answer: reactNodeToSanitizedText(faq.answer),
    }));

    const logomakerCTARef = useTrackNavigationClicked(
        'Design Services',
        'FAQ section CTA',
        logomakerCtaPathByLocale(locale),
        'logoMaker',
    );

    return (
        <BoundedContent marginY="between-sections">
            <GridContainer>
                <Row>
                    <Column span={12} padding={0}>
                        <H2 fontSkin="title-section">
                            {/* TODO: Update when FAQ copy is finalised */}
                            Your Logomaker questions, answered.
                        </H2>
                        <Box marginTop="between-subsections" marginBottom="to-actions">
                            <FAQAccordion faqData={faqData} faqSchemaData={faqSchemaData} />
                        </Box>
                        <FlexBox justifyContent="center">
                            <LogomakerCTA ctaRef={logomakerCTARef} />
                        </FlexBox>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
};

export default Faq;
